import { useDelegateRequestModal } from './useDelegateRequestModal'
import { useCancelRequestModal } from './useCancelRequestModal'
import { useCompleteRequestConfirm } from './useCompleteRequestConfirm'

export const RequestViewActions = ({ crudContext }: any) => {
    const { Modal: DelegateModal } = useDelegateRequestModal({ crudContext })
    const { Modal: CancelModal } = useCancelRequestModal({ crudContext })
    const { Modal: CompleteModal } = useCompleteRequestConfirm({ crudContext })

    return (
        <>
            <DelegateModal />
            <CancelModal />
            <CompleteModal />
        </>
    )
}
